import { render, staticRenderFns } from "./OrdersFBMTableUserTableMobile.vue?vue&type=template&id=22bf77a6&scoped=true"
import script from "./OrdersFBMTableUserTableMobile.vue?vue&type=script&lang=js"
export * from "./OrdersFBMTableUserTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf77a6",
  null
  
)

export default component.exports